import { ValidationRule } from "@/declarations/ValidationRule";
import IFormModel from "@/models/IFormModel";
import TranslatedValueCreate from "@/models/translated-value/TranslatedValueCreate";
import BrandRules from "@/models/brand/BrandRules";

export default class BrandCreate implements IFormModel {
	public name: string | null = null;
	public description: TranslatedValueCreate = new TranslatedValueCreate();

	public reset(): void {
		this.name = null;
		this.description = new TranslatedValueCreate();
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'name':
				return BrandRules.nameRules;
			default:
				return [];
		}
	}
}
